import { DateOrderPipe } from "./date-order.pipe";
import { LocalizePipe } from "./localize.pipe";
import { SafePipe } from "./safe.pipe";
import { DatePipe } from "./date.pipe";
import { RemoveSpacesPipe } from "./removeSpaces.pipe";
import { BytesToSizePipe } from "./bytestosize.pipe";
import { SentenceCasePipe } from "./sentence-case.pipe";
import { StripHtmlPipe } from "./strip-html.pipe";

export const PIPES = [DateOrderPipe, LocalizePipe, SafePipe, DatePipe, BytesToSizePipe, RemoveSpacesPipe, SentenceCasePipe, StripHtmlPipe];
export * from "./localize.pipe";
